import modalConfirmation from '../modal-response/modal-response.view.html';
import ProductDetailService from "../../../catalog/product-detail/product-detail.service";
// import modalQuantityCart from '../modal-quantity-cart/modal-quantity-cart.view.html';
// import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';

let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'SharedService',
    'ngAuthSettings',
    '$uibModal',
    '$timeout',
    'ProductDetailService'
];

class TestimoniesController {
    constructor($scope, $state, $rootScope, SharedService, ngAuthSettings, $uibModal, $timeout,ProductDetailService) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.ngAuthSettings = ngAuthSettings;
        this.$rootScope = $rootScope;
        this.SharedService = SharedService;
        this.productsInfo = {};
        this.imageData = [];
        this.ProductDetailService = ProductDetailService;
    }

    $onInit() {
        this.getBrands(this.itemId);
    }

    getBrands(itemId = '') {

        this.ProductDetailService.getProductComments(itemId).then(response => {

            let val = this;
            angular.forEach(response.data, function (value, key) {
                val.imageData.push({
                    img: value.imagen,
                    titulo: value.nombre_item,
                    usuario_nombre: value.usuario_nombre,
                    fecha: value.fecha,
                    description: value.comentario
                });
            });

            if (this.imageData.length > 0) {
                this.initBrandsCarousel();
            }

        }).catch(error => {});
    }

    initBrandsCarousel() {
        this.$timeout(function () {

            let testimoniesItemsSlider = $('.testimonies-slider');
            testimoniesItemsSlider.owlCarousel({
                items: 1,
                itemsDesktop: [1199, 1],
                itemsDesktopSmall: [979, 1],
                itemsTablet: [768, 1],
                itemsMobile: [479, 1],
                slideSpeed: 400,
                autoPlay: 8000,
                stopOnHover: true,
                navigation: false,
                pagination: false,
                responsive: true,
                mouseDrag: false,
                autoHeight: false
            }).data('navigationBtns', ["#testimonies-slider-prev", "#testimonies-slider-next"]);
            testimoniesItemsSlider.each(function () {
                let $this = $(this),
                    owlCarousel = $this.data('owlCarousel'),
                    owlBtns = $this.data('navigationBtns'),
                    prevBtn, nextBtn;

                if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
                    return;
                }

                for (let key in owlBtns) {
                    if (owlBtns[key].indexOf('next') === -1) {
                        prevBtn = $(owlBtns[key]);
                    } else {
                        nextBtn = $(owlBtns[key]);
                    }
                }

                prevBtn.on('click touchstart', function (e) {
                    owlCarousel.prev();
                    e.preventDefault();
                });

                nextBtn.on('click touchstart', function (e) {
                    owlCarousel.next();
                    e.preventDefault();
                });
            });

            $('.add-tooltip').tooltip();
        }, 1000);
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

}

TestimoniesController.$inject = inject;

export default TestimoniesController;




/** WEBPACK FOOTER **
 ** ./www/components/shared/components/testimonies/testimonies.controller.js
 **/